<section id="postapp-overview-summary" class="bl-bg-color--white bl-padding-x--24 bl-width--100 bl-box-shadow">
  <div
    *ngIf="applicationSummary; else overviewLoader"
    class="bl-display--flex bl-text-align--left bl-padding-y--16 bl-padding-top-md--48 bl-padding-bottom-md--48 bl-margin-bottom--24 bl-bg-color--white bl-width--100 dx-postapp-max-width"
  >
    <div class="postapp-image-container bl-display--flex bl-align-items--center bl-flex-direction--column bl-margin-right--8">
      <!-- questions on this? see comments in dx-product-image component -->
      <dx-product-image
        id="app-icon"
        class="bl-margin-bottom--8"
        [icon]="applicationSummary?.selectedLoanGroupIcon"
        [product]="loanType"
        [flowType]="postapp.applicationType"
      ></dx-product-image>
      <p *ngIf="applicationType === 'ola'" class="bl-font-color--slate bl-font-size--12 bl-font-weight--800 bl-text-align--center">
        {{ loanType | uppercase }}
      </p>
    </div>

    <div class="bl-display-md--block bl-flex--auto bl-padding-left--24">
      <!-- OAO OVERVIEW BANNER -->
      <div *ngIf="applicationType === 'oao'" id="oao-app-summary" class="">
        <div class="bl-display--flex bl-align-items--center bl-margin-bottom--8">
          <h2 class="bl-font-color--slate bl-font-size--12 bl-font-weight--800 bl-margin-bottom--0">
            {{ applicationSummary?.loanProductDisplayName | uppercase }}
          </h2>
        </div>
        <p class="bl-text-style--display-3 bl-text-style-mobile--default-2 bl-margin-bottom--16">
          {{
            applicationSummary?.postAppStatusMessage
              | replace
                : {
                    FirstName$: this.applicantFirstName
                  }
          }}
        </p>
        <p
          id="overview-app-id"
          [attr.data-appId]="applicationSummary.appNumber"
          class="bl-text-style--secondary-text-1 bl-margin-bottom--4"
        >
          Application: {{ applicationSummary.appNumber }}
        </p>
        <p *ngIf="applicationSummary?.accountNames?.length" class="bl-text-style--secondary-text-1 bl-margin-bottom--4">
          {{ applicationSummary.accountsNamesLabel }}:
          <span class="bl-text-style--secondary-text-2">
            {{ applicationSummary.accountNames }}
          </span>
        </p>
      </div>
      <!-- OAO OVERVIEW BANNER END -->

      <!-- OLA OVERVIEW BANNER -->
      <!-- TODO : Having a separate story to implement OLA Overview Banner New Design -->
      <div id="olaBanner" *ngIf="applicationType === 'ola'">
        <div id="ola-app-summary">
          <div>
            <!-- <p
            class="bl-text-style--secondary-text-2 bl-display-sm--flex bl-justify-content--center postapp-justify-content-md--flex-start bl-align-items--center bl-margin-bottom--8">
            {{ 'overviewBanner/application' | dictionary }}
            <span class="bl-text-transform--uppercase bl-margin-left--4" [attr.data-appId]="applicationSummary?.appNumber">{{ applicationSummary?.appNumber }}</span>
          </p> -->
            <p class="bl-font-color--slate bl-font-size--12 bl-font-weight--800 bl-margin-bottom--8">
              {{ applicationSummary?.loanProductDisplayName | uppercase }}
            </p>
            <h2 class="bl-text-style--display-3 bl-text-style-mobile--default-2 bl-margin-bottom--16">
              {{
                applicationSummary?.postAppStatusMessage
                  | replace
                    : {
                        FirstName$: this.applicantFirstName,
                        RequestedAmount$: applicationSummary.requestedLoanAmount | currency : 'USD' : 'symbol' : '1.2-2',
                        DecisionedAmount$: applicationSummary.decision.amount | currency : 'USD' : 'symbol' : '1.2-2'
                      }
              }}
            </h2>
            <p *ngIf="helocLoanType()" class="bl-text-style--secondary-text-1 bl-margin-bottom--4">
              {{ fullPropertyAddress() }}
            </p>
            <div class="bl-display-md--flex bl-flex-flow--wrap">
              <ng-container [ngTemplateOutlet]="loanDetails"></ng-container>
            </div>
          </div>
        </div>
        <!-- <div id="app-status" class="postapp-border-md--left bl-margin-x--auto bl-padding-left-md--24">
        <p id="app-state" *ngIf="!isLoading else loaderStatusDesc" class="bl-tag" [ngClass]="applicationStatusStyle">
          <i *ngIf="applicationSummary?.loanStatus == inprogress" class="cu-spinner-dots bl-font-size--12"></i>
          {{ configuredStatusText || applicationSummary?.loanStatus | titlecase }}
        </p>
        <div *ngIf="!isLoading  else loaderStatusDesc">
          <p *ngIf="applicationSummary?.loanStatusDescription && showStatusDescription()" id="app-state-description"
            class="bl-font-color--steel bl-font-size--12">
            {{applicationSummary?.loanStatusDescription}}
          </p>
        </div>
        <div class="bl-display--none bl-display-md--block">
          <ng-container [ngTemplateOutlet]="loanOfficerInfo"></ng-container>
        </div>
      </div>
      <div class="bl-display-md--none bl-display--inline-block bl-text-align--center bl-text-align-md--left bl-margin-x--auto">
        <div>
          <ng-container [ngTemplateOutlet]="loanDetails"></ng-container>
          <div class="bl-margin-top--16">
            <ng-container [ngTemplateOutlet]="loanOfficerInfo"></ng-container>
          </div>
        </div>
      </div> -->
      </div>
      <!-- OLA OVERVIEW BANNER END -->

      <!-- OLA OVERVIEW BANNER -->
      <!-- TODO : Having a separate story to implement OLA Overview Banner New Design -->
      <!-- <ng-container *ngIf="applicationType === 'ola'">
      <div id="app-summary" class="bl-flex--auto bl-padding-left--32 bl-padding-right--24">
        <p
          class="bl-text-style--secondary-text-2 bl-display-sm--flex bl-justify-content--center postapp-justify-content-md--flex-start bl-align-items--center bl-margin-bottom--8">
          {{ 'overviewBanner/application' | dictionary }}
          <span class="bl-text-transform--uppercase bl-margin-left--4"
            [attr.data-appId]="applicationSummary?.appNumber">{{ applicationSummary?.appNumber }}</span>
          <span class="bl-display--none bl-display-sm--block bl-margin-x--8">&#8226;</span>
          <span class="bl-display--block bl-text-transform--capitalize">{{ applicationTypeDisplayName }}</span>
        </p>
        <p class="bl-text-style--display-4 bl-margin-bottom--8">
          {{applicationSummary?.loanProductName}}
        </p>
        <div class="bl-display--none bl-display-md--block">
          <ng-container [ngTemplateOutlet]="loanDetails"></ng-container>
        </div>
      </div>
      <div id="app-status" class="postapp-border-md--left bl-margin-x--auto bl-padding-left-md--24">
        <p id="app-state" *ngIf="!isLoading else loaderStatusDesc" class="bl-tag" [ngClass]="applicationStatusStyle">
          <i *ngIf="applicationSummary?.loanStatus == inprogress" class="cu-spinner-dots bl-font-size--12"></i>
          {{ configuredStatusText || applicationSummary?.loanStatus | titlecase }}
        </p>
        <div *ngIf="!isLoading  else loaderStatusDesc">
          <p *ngIf="applicationSummary?.loanStatusDescription && showStatusDescription()" id="app-state-description"
            class="bl-font-color--steel bl-font-size--12">
            {{applicationSummary?.loanStatusDescription}}
          </p>
        </div>
        <div class="bl-display--none bl-display-md--block">
          <ng-container [ngTemplateOutlet]="loanOfficerInfo"></ng-container>
        </div>
      </div>
      <div
        class="bl-display-md--none bl-display--inline-block bl-text-align--center bl-text-align-md--left bl-margin-x--auto">
        <div>
          <ng-container [ngTemplateOutlet]="loanDetails"></ng-container>
          <div class="bl-margin-top--16">
            <ng-container [ngTemplateOutlet]="loanOfficerInfo"></ng-container>
          </div>
        </div>
      </div>
    </ng-container> -->
      <!-- OLA OVERVIEW BANNER END -->
      <!-- OLA/OAO Condition stipulations  -->
      @if (conditions?.length) {
      <ng-template #conditionTemplate>
        <ul clas="bl-bulleted-list">
          @for (cond of conditions; track $index) {
          <li class="bl-padding-x--4 bl-text-style--secondary-text-1 bl-display--flex">
            <span class="bl-margin-right--8">&#x2022;</span>
            <div>
              {{ cond.name }}
            </div>
          </li>
          }
        </ul>
      </ng-template>
      <div class="bl-display-sm--block" [class.bl-display--none]="conditionsExceedsInline">
        <div class="bl-display-md--flex bl-align-items--center">
          <span class="bl-text-style--secondary-text-2 bl-display-md--flex bl-margin-right--4"> Conditions for approval: </span>
        </div>
        <ng-container *ngTemplateOutlet="conditionTemplate"></ng-container>
      </div>
      @if(conditionsExceedsInline){
      <button
        id="btnCondition"
        type="button"
        class="bl-display-sm--none bl-font-color--primary bl-text-style--teritary-text-2 bl-font-weight--700 bl-text-decoration--underline"
        (click)="showConditions = true"
      >
        Conditions for approval
      </button>

      <ea-slide-in-panel [(isSlidePanelVisible)]="showConditions" slidePanelTitle="Conditions for approval" class="half-panel">
        <div class="bl-display--flex bl-flex-direction--column bl-justify-content--space-between bl-overflow--auto bl-height--100">
          <div
          class="bl-bg-color--white bl-margin-bottom--24 bl-border bl-border-radius--16 bl-padding--24 bl-max-width--tablet-width bl-overflow-wrap--break-word bl-font-color--black"
        >
          <div class="">
            <div class="bl-display-md--flex bl-align-items--center bl-margin-bottom--8">
              <span class="bl-text-style--default-text-2 bl-display-md--flex"> Conditions for approval: </span>
            </div>
            <ng-container *ngTemplateOutlet="conditionTemplate"></ng-container>
          </div>
        </div>
        <div class="bl-text-align--center bl-position--sticky bl-bottom--0">
          <button type="button" class="bl-button bl-button-primary bl-width--100" (click)="showConditions = false">Close</button>
        </div>
        </div>
      </ea-slide-in-panel>
      } }
    </div>
  </div>
</section>

<!-- Note: 'lineBreak' breaks data into a new line, makes it full with and removes the bullet separator (if applicable) -->

<!-- loan details -->
<ng-template #loanDetails>
  <ng-container *ngIf="loanDetailFields">
    <!-- <ng-container [ngTemplateOutlet]="rate" [ngTemplateOutletContext]="{css: 'bl-margin-bottom--0'}"></ng-container> -->
    <ng-container *ngFor="let field of loanDetailFields; let i = index">
      <ng-container
        [ngTemplateOutlet]="this[field.template]"
        [ngTemplateOutletContext]="{ css: 'bl-margin-bottom--4 ' + field.css, lineBreak: field.lineBreak, label: field.label, index: i }"
      >
      </ng-container>
    </ng-container>
  </ng-container>
</ng-template>

<!-- loan details -->
<!-- <ng-template #loanDetails>
  <ng-container *ngIf="applicationType?.toLowerCase() === 'ola' && applicationSummary?.decision">
    <ng-container *ngIf="!helocLoanType() && applicationSummary?.decision.amount > 0"
      [ngTemplateOutlet]="approvedAmount"
      [ngTemplateOutletContext]="{css: helocLoanType() ? 'bl-margin-bottom--0' : 'bl-margin-bottom--8'}">
    </ng-container>
    <p *ngIf="helocLoanType()" class="bl-text-style--secondary-text-1 bl-margin-bottom--8">
      {{fullPropertyAddress()}}
    </p>
    <div *ngIf="!creditCardType()" class="bl-display-xl--flex bl-align-items--center bl-margin-bottom--8">
      <p *ngIf="!helocLoanType() && !applicationSummary?.isRevolving"
        class="bl-text-style--secondary-text-2 bl-margin-bottom--8 bl-margin-bottom-xl--0">
        <ng-container *ngIf="showMonthlyPayment" [ngTemplateOutlet]="payment"
          [ngTemplateOutletContext]="{css: 'bl-display--inline'}"></ng-container>
        <ng-container *ngIf="showTerm" [ngTemplateOutlet]="term"
          [ngTemplateOutletContext]="{css: 'bl-margin-bottom--0 bl-display--inline'}">
        </ng-container>
      </p>
      <span *ngIf="(showMonthlyPayment || showTerm) && showRate && !applicationSummary?.isRevolving"
        class="bl-display--none bl-display-xl--block bl-margin-x--4">&#8226;</span>
      <ng-container *ngIf="showRate">
        <ng-container [ngTemplateOutlet]="rate" [ngTemplateOutletContext]="{css: 'bl-margin-bottom--0'}"></ng-container>
      </ng-container>
    </div>
  </ng-container>
  <p *ngIf="applicationSummary?.applicants?.length"
    class="bl-text-style--secondary-text-1 bl-text-transform--capitalize bl-margin-bottom--8">
    {{ applicationSummary?.applicants?.length > 1
    ? ('overviewBanner/applicants' | dictionary)
    : ('overviewBanner/applicant' | dictionary)
    }}
    <ng-container *ngFor="let applicant of applicationSummary?.applicants; let lastApplicant = last">
      <span class="bl-margin-left--4">{{ applicant.firstName }} {{ applicant.lastName }}</span>
      <span *ngIf="!lastApplicant">,</span>
    </ng-container>
  </p>
</ng-template> -->

<!-- Rate -->
<ng-template #rate let-css="css" let-lineBreak="lineBreak" let-label="label" let-index="index">
  <p class="bl-text-style--secondary-text-2 bl-display-md--flex bl-align-items--center {{ css }}" [class.bl-flex-basis--100]="lineBreak">
    <span class="bl-text-style--secondary-text-1 bl-display-md--flex bl-margin-right--4">
      <span class="bl-display--none bl-display-md--block bl-margin-x--8" *ngIf="!lineBreak">&#8226;</span>
      {{ label }}:
    </span>
    <span class="bl-margin-right--4">
      {{
        isFundedLoan && +applicationSummary?.fundedRate > 0
          ? (+applicationSummary?.fundedRate / 100 | percent : '0.2')
          : (+applicationSummary?.decision?.rate / 100 | percent : '0.2')
      }}
      {{ 'overviewBanner/loanAPR' | dictionary }}
    </span>
  </p>
</ng-template>

<!-- Payment -->
<ng-template #payment let-css="css" let-lineBreak="lineBreak" let-label="label" let-index="index">
  <p class="bl-text-style--secondary-text-2 bl-display-md--flex {{ css }}" [class.bl-flex-basis--100]="lineBreak">
    <span class="bl-text-style--secondary-text-1 bl-display-md--flex bl-margin-right--4">
      <span class="bl-display--none bl-display-md--block bl-margin-x--8" *ngIf="!lineBreak">&#8226;</span>
      {{ label }}:
    </span>
    <span class="bl-margin-right--4">
      {{
        isFundedLoan && +applicationSummary?.monthlyFundedPayment > 0
          ? (applicationSummary?.monthlyFundedPayment | currency : 'USD')
          : (applicationSummary?.decision?.estMonthlyPayment | currency : 'USD')
      }}{{ 'overviewBanner/loanEstPaymentFrequency' | dictionary }}
      <span *ngIf="isLoanApproved || !ignoreLoanAmountSettings" class="bl-text-style--secondary-text-1">
        for
        {{ isFundedLoan && +applicationSummary?.fundedTerm > 0 ? applicationSummary?.fundedTerm : applicationSummary?.decision?.term }}
        {{ 'overviewBanner/loanEstPaymentTerm' | dictionary }}
      </span>
    </span>
  </p>
</ng-template>

<!-- Application -->
<ng-template #application let-css="css" let-label="label" let-index="index" let-lineBreak="lineBreak">
  <p class="bl-display-md--flex {{ css }} bl-text-style--secondary-text-1" [class.bl-flex-basis--100]="lineBreak">
    <span class="bl-display-md--flex bl-margin-right--4"> {{ label }}: </span>
    <span class="bl-margin-right--4" id="overview-app-id" [attr.data-appId]="applicationSummary.appNumber">
      {{ applicationSummary?.appNumber?.toString().includes('OLA') ? 'NA' : applicationSummary?.appNumber }}
    </span>
  </p>
</ng-template>

<!-- Requested Amount -->
<ng-template #requestedamount *ngIf="!ignoreLoanAmountSettings" let-css="css" let-lineBreak="lineBreak" let-label="label" let-index="index">
  <p class="bl-text-style--secondary-text-2 bl-display-md--flex {{ css }}" [class.bl-flex-basis--100]="lineBreak">
    <span class="bl-text-style--secondary-text-1 bl-display-md--flex bl-margin-right--4">
      <span class="bl-display--none bl-display-md--block bl-margin-x--8" *ngIf="!lineBreak">&#8226;</span>
      {{ label }}:
    </span>
    <span class="bl-margin-right--4">
      {{
        +applicationSummary?.requestedLoanAmount > 0
          ? (applicationSummary?.requestedLoanAmount | currency : 'USD' : 'symbol' : '1.0')
          : +applicationSummary?.decision?.amount > 0
          ? (applicationSummary?.decision?.amount | currency : 'USD' : 'symbol' : '1.0')
          : ('overviewBanner/amountNotAvailable' | dictionary)
      }}
      <i *ngIf="loanCounterOffer" class="cu-payment-information bl-text-style--secondary-text-1 bl-margin-left--4"></i>
    </span>
  </p>
</ng-template>

<!-- Approved Amount -->
<!-- <ng-template #amount let-css="css" let-label="label" let-index="index">
  <p class="bl-text-style--secondary-text-2 bl-display--flex {{css}}">
    <span class="bl-text-style--secondary-text-1 bl-display--flex bl-margin-right--4">
      <span class="bl-display--none bl-display-md--block bl-margin-x--8" *ngIf="index % 2">&#8226;</span>
      {{label}}:
    </span>
    <span class="bl-margin-right--4">
      {{
      isFundedLoan && applicationSummary?.fundedAmount > 0
      ? (applicationSummary?.fundedAmount | currency: 'USD':'symbol':'1.0')
      : (applicationSummary?.decision?.amount) > 0
      ? (applicationSummary?.decision?.amount | currency: 'USD':'symbol':'1.0')
      : ('overviewBanner/amountNotAvailable' | dictionary)
      }}
    </span>
  </p>
</ng-template> -->

<!-- Term -->
<ng-template #term let-css="css" let-data="data" let-index="index">
  <p class="bl-text-style--secondary-text-2 {{ css }}">
    <span class="bl-font-weight--400">
      {{ showMonthlyPayment && showTerm ? 'for' : ('overviewBanner/loanTerm' | dictionary) }}
      <span [class.bl-font-weight--800]="!showMonthlyPayment && showTerm">
        {{ isFundedLoan && +applicationSummary?.fundedTerm > 0 ? applicationSummary?.fundedTerm : applicationSummary?.decision?.term }}
        {{ 'overviewBanner/loanEstPaymentTerm' | dictionary }}
      </span>
    </span>
  </p>
</ng-template>

<!-- minimized overview UI (used in tasks page) -->
<!-- <ng-template #minimizedBannerUI>
  <section class="bl-padding-x--16 bl-padding-x-lg--40">
    <ng-container *ngIf="applicationSummary; else minimizedLoader">
      <div
        class="bl-display-md--flex bl-align-items--center bl-text-align--center bl-text-align-md--left bl-padding-top--48 bl-padding-top--24 bl-width--100 dx-postapp-max-width">
        <dx-product-image id="app-icon" [product]="applicationTypeName" [size]="'64px'"
          class="bl-display--block bl-margin-right-sm--32" [flowType]="postapp.applicationType"></dx-product-image>
        <div *ngIf="applicationType?.toLowerCase() === 'ola' && applicationSummary?.decision"
          class="bl-display-md--flex bl-flex-flow--wrap bl-align-items--center bl-width--100">
          <p class="bl-text-style--secondary-text-2 bl-margin-bottom--8 bl-margin-right-sm--24">
            <span class="bl-font-weight--400 bl-margin-right--4">Status:</span>
            {{ configuredStatusText || applicationSummary?.loanStatus | titlecase }}
          </p>
          <ng-container *ngIf="!helocLoanType() && applicationSummary?.decision.amount > 0"
            [ngTemplateOutlet]="requestedAmount"
            [ngTemplateOutletContext]="{css: 'bl-margin-bottom--8 bl-margin-right-sm--24'}">
          </ng-container>
          <ng-container *ngIf="!creditCardType()">
            <p *ngIf="!helocLoanType() && !applicationSummary?.isRevolving"
              class="bl-text-style--secondary-text-2 bl-margin-bottom--8 bl-margin-right-sm--24">
              <ng-container *ngIf="showMonthlyPayment" [ngTemplateOutlet]="payment"
                [ngTemplateOutletContext]="{css: 'bl-display--inline-block bl-margin--0'}">
              </ng-container>
              <ng-container *ngIf="showTerm" [ngTemplateOutlet]="term"
                [ngTemplateOutletContext]="{css: 'bl-display--inline-block bl-margin-bottom--0 bl-margin-left--4'}">
              </ng-container>
            </p>
            <ng-container *ngIf="showRate" [ngTemplateOutlet]="rate"
              [ngTemplateOutletContext]="{css: 'bl-margin-bottom--8 bl-margin-right-sm--24'}">
            </ng-container>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </section>
</ng-template> -->

<!-- Skeleton Loader UI -->
<!-- Full overview banner -->
<ng-template #overviewLoader>
  <div
    class="bl-loader-skeleton loading bl-display-md--flex bl-text-align--center bl-text-align-md--left bl-padding-y--48 bl-margin-bottom--40 bl-bg-color--white bl-width--100 dx-postapp-max-width"
  >
    <div class="sl-product-icon bl-skeleton-loader--self bl-margin-x--auto"></div>
    <div
      id="app-summary"
      class="bl-flex--auto bl-padding-left--32 bl-padding-right--24 bl-display--flex bl-flex-direction--column bl-align-items--center bl-display-md--block"
    >
      <p class="bl-skeleton-loader--self bl-text-style--secondary-text-2 bl-margin-bottom--8 bl-width--50">Details</p>
      <p class="bl-skeleton-loader--self bl-text-style--display-4 bl-margin-bottom--8 bl-width--75">Details</p>
      <p class="bl-skeleton-loader--self bl-text-style--secondary-text-2 bl-margin-bottom--8 bl-width--50">Details</p>
      <p class="bl-skeleton-loader--self bl-text-style--secondary-text-2 bl-margin-bottom--8 bl-width--50">Details</p>
    </div>
    <div id="app-status" class="postapp-border-md--left bl-margin-x--auto bl-padding-left-md--24">
      <p id="app-state" class="bl-skeleton-loader--self bl-tag bl-width--33">Status</p>
      <p id="app-state-description" class="bl-skeleton-loader--self bl-font-color--steel bl-font-size--12">Details</p>
    </div>
  </div>
</ng-template>

<ng-template #loaderStatusDesc>
  <div class="bl-loader-skeleton loading">
    <div id="app-status" class="postapp-border-md--left">
      <p id="app-state-description" class="bl-skeleton-loader--self">Details test</p>
    </div>
  </div>
</ng-template>
<!-- Minimized overview banner (tasks page)-->
<ng-template #minimizedLoader>
  <div
    class="bl-loader-skeleton loading bl-display-md--flex bl-text-align--center bl-text-align-md--left bl-padding-top--48 bl-padding-top--24 bl-width--100 dx-postapp-max-width"
  >
    <div class="sl-product-icon-small bl-skeleton-loader--self bl-margin-x--auto bl-padding-right-sm--32"></div>
    <div class="bl-display-md--flex bl-flex-flow--wrap bl-align-items--center bl-width--100">
      <p
        class="bl-skeleton-loader--self bl-text-style--secondary-text-2 bl-margin-bottom--8 bl-flex--auto bl-margin-x--16 bl-border-radius"
      >
        Details
      </p>
      <p
        class="bl-skeleton-loader--self bl-text-style--secondary-text-2 bl-margin-bottom--8 bl-flex--auto bl-margin-x--16 bl-border-radius"
      >
        Details
      </p>
      <p
        class="bl-skeleton-loader--self bl-text-style--secondary-text-2 bl-margin-bottom--8 bl-width--25 bl-margin-x-sm--16 bl-border-radius bl-margin-x--auto"
      >
        Details
      </p>
      <p
        class="bl-skeleton-loader--self bl-text-style--secondary-text-2 bl-margin-bottom--8 bl-width--25 bl-margin-x-sm--16 bl-border-radius bl-margin-x--auto"
      >
        Details
      </p>
    </div>
  </div>
</ng-template>
